<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>

<p-fieldset>

    <ng-template pTemplate="header">{{lbl_participants}}</ng-template>
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="redirectParticipant()"></button>
        </ng-template>
    </p-toolbar>

    <!-- Main Info -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                    <span>{{lbl_church_name}}</span>
                    <span class="p-text-bold">{{workshop != null && workshop.chr != null ? workshop.chr.name : ""}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_workshop}}</span>
                    <span class="p-text-bold">{{workshop != null  ? workshop.wst.wsName : ""}} </span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_schedule}}</span>
                    <span class="p-text-bold">{{workshop != null && workshop.f0 != null ? workshop.f0.fromTime : ""}} - {{workshop != null &&  workshop.f0 != null?
                        workshop.f0.toTime : ""}}</span>
                </div>

            </p-panel>
        </div>
    </div>

    <!-- Main Card -->
    <div class="card">

        <!-- Grid -->
        <div class="p-grid">
            <!-- 1st Section -->
            <div class="p-col-12 p-md-6">

                <div class="p-fluid">
                    <h5>{{lbl_personal_information}}</h5>

                    <!-- Name -->
                    <div class="p-col-12">
                        <label for="namePart">{{lbl_name}} <span style="color:red">
                                (*)</span></label>
                        <input type="text" maxlength="30" [(ngModel)]="namePart" pInputText>
                    </div>

                    <!-- Last name -->
                    <div class="p-col-12">
                        <label for="lastNamePart">{{lbl_last_name}} <span style="color:red"> (*)</span></label>
                        <input type="text" maxlength="35" [(ngModel)]="lastNamePart" pInputText>
                    </div>

                    <!-- Language -->
                    <div class="p-col-12">
                        <label for="listLanguage">{{lbl_language}}</label>
                        <p-dropdown [options]="listLanguage" [(ngModel)]="selectedLanguage"
                            placeholder="{{lbl_select}} {{lbl_language}}" optionLabel="value"
                            [showClear]="true"></p-dropdown>
                    </div>

                    <!-- Age -->
                    <div class="p-col-12">
                        <div class=" p-fluid p-formgrid p-grid church_field">
                            <div class="p-col-12 p-md-6">
                                <label for="birthday">{{lbl_birth_Date}}</label>
                                <p-inputMask mask="99/99/9999" placeholder="DD/MM/YYYY"
                                    pattern="^(0[1-9]|1[0-9]|2[0-9]|3[0-1])/(0[1-9]|1[0-2])/(\d{4})$"
                                    [(ngModel)]="birthday" (ngModelChange)="calculateAge()"></p-inputMask>

                            </div>
                            <div class="p-col-12 p-md-6">
                                <label for="age">{{lbl_age}}</label>
                                <p-inputNumber [(ngModel)]="age" inputId="minmax" mode="decimal" [min]="18" [max]="100"
                                    [showButtons]="true" [disabled]="true"></p-inputNumber>
                            </div>
                        </div>
                    </div>

                    <!-- Gender -->
                    <div class="p-col-12">
                        <label for="listGender">{{lbl_gender}}</label>
                        <p-dropdown [options]="listGender" [(ngModel)]="selectedGender"
                            placeholder="{{lbl_select}} {{lbl_gender}}" optionLabel="descrip"
                            [showClear]="true"></p-dropdown>
                    </div>


                    <!-- Email -->
                    <div class="p-col-12">
                        <label for="email">{{lbl_email}}</label>
                        <input type="text" maxlength="50" [(ngModel)]="email" pInputText>
                    </div>

                    <!-- Phone -->
                    <div class="p-col-12">
                        <div class=" p-fluid p-formgrid p-grid church_field">
                            <div class="p-col-12 p-md-6">
                                <label for="cellPhone">{{lbl_cell_phone}}</label>
                                <input maxlength="20" type="text" [(ngModel)]="cellPhone" pInputText>
                            </div>
                            <div class="p-col-12 p-md-6">
                                <label for="homeNumber">{{lbl_home_phone}}</label>
                                <input maxlength="20" type="text" [(ngModel)]="homeNumber" pInputText>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 2nd Section -->
            <div class="p-col-12 p-md-6">
                <div class="p-fluid">
                    <h5>{{lbl_address}}</h5>

                    <div class="p-col-12">
                        <label for="listState">{{lbl_state}} </label>
                        <p-dropdown [options]="listState" [(ngModel)]="selectedState"
                            placeholder="{{lbl_select}} {{lbl_state}}" optionLabel="descrip" [showClear]="true"
                            [filter]="true"></p-dropdown>
                    </div>

                    <div class="p-col-12">
                        <label for="city">{{lbl_county_city}} </label>
                        <input maxlength="40" type="text" [(ngModel)]="city" pInputText>
                    </div>

                    <div class="p-col-12">
                        <label for="neight">{{lbl_neightborhood}} </label>
                        <input maxlength="30" type="text" [(ngModel)]="neight" pInputText>
                    </div>

                    <div class="p-col-12">
                        <label for="street">{{lbl_street_and_number}} </label>
                        <input maxlength="50" type="text" [(ngModel)]="street" pInputText>
                    </div>
                    <div class="p-col-12">
                        <label for="zipcode">{{lbl_zip_code}} </label>
                        <input maxlength="10" type="text" [(ngModel)]="zipcode" maxlength="10" pInputText>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12 p-md-6"></div>
            <div class="p-col-12 p-md-6">
                <!-- Buttons -->
                <div class="p-col-12">
                    <div class=" p-fluid p-formgrid p-grid church_field">
                        <div class="p-col-12 p-md-4"></div>
                        <div class="p-col-12 p-md-4">
                            <div class="p-field">
                                <button pButton pRipple type="button" icon="pi pi-plus" label="{{lbl_save}}"
                                    class="p-button-raised p-button-success" (click)="saveParticipant()"></button>
                            </div>
                        </div>
                        <div class="p-col-12 p-md-4">
                            <div class="p-field">
                                <button pButton pRipple type="button" icon="pi pi-trash" label="{{lbl_delete}}"
                                    class="p-mr-2 p-mb-2 p-button-raised p-button-danger" (click)="deleteParticipant()"
                                    [disabled]="this.participant != null ? false : true"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-fieldset>